module.exports = __webpack_public_path__ + "img/verloop-sample-livechat.0019bc3e.png";